import {Nullable} from "../../models/common/Nullable";
import {
    errorFetchingRequestState,
    getInitialRequestState,
    RequestState,
    startFetchingRequestState,
    successFetchingRequestState
} from "../../models/common/RequestState";
import {OutgoingInvoiceProjectTaskTimeItem} from "../../models/accounting/OutgoingInvoiceProjectTaskTimeItem";
import {
    FETCH_OUT_INVOICES_PROJECT_TASK_TIME_ITEM,
    FETCH_OUT_INVOICES_PROJECT_TASK_TIME_ITEM_ERROR,
    FETCH_OUT_INVOICES_PROJECT_TASK_TIME_ITEM_SUCCESS,
    OutgoingInvoiceProjectTaskTimeItemViewActionTypes
} from "../../actions/account-book/OutInvoiceProjectTaskTimeItemActions";

export type InvoiceItemFetchState<T> = {
    entries: T
    request: RequestState
}

export interface OutgoingInvoiceProjectTaskTimeItemsState {
    timeItems: InvoiceItemFetchState< Nullable< OutgoingInvoiceProjectTaskTimeItem[] > >
}

const initialState: OutgoingInvoiceProjectTaskTimeItemsState = {
    timeItems: {
        request: getInitialRequestState(),
        entries: null
    }
};

export function OutgoingInvoiceProjectTaskTimeItemsReducer(
    state: OutgoingInvoiceProjectTaskTimeItemsState = initialState,
    action: OutgoingInvoiceProjectTaskTimeItemViewActionTypes
) {

    switch (action.type) {
        case FETCH_OUT_INVOICES_PROJECT_TASK_TIME_ITEM:
            return {
                ...state,
                timeItems: {
                    entries: null,
                    request: startFetchingRequestState()
                }
            };
        case FETCH_OUT_INVOICES_PROJECT_TASK_TIME_ITEM_SUCCESS:
            return {
                ...state,
                timeItems: {
                    entries: action.payload,
                    request: successFetchingRequestState()
                }
            };
        case FETCH_OUT_INVOICES_PROJECT_TASK_TIME_ITEM_ERROR:
            return {
                ...state,
                timeItems: {
                    ...state.timeItems,
                    request: errorFetchingRequestState( action.error )
                }

            };
        default:
            return state;
    }
}